import AppRecord from './AppRecord.js'
import APP from '../../../main.js'

class Issue extends AppRecord {
  get vehicle_cost_estimates(){
    return this.constructor.employeeStore.vehicle_cost_estimates.filter(vce => vce.issue_id === this.id)
  }
  get coracts(){
    return this.constructor.employeeStore.coracts.filter(cor => cor.issue_id === this.id)
  }
  set coracts(cors){
    this.setRelatedData(cors, 'CoractsController')
  }
  set vehicle_cost_estimates(vces){
    this.setRelatedData(vces, 'VehicleCostEstimatesController')
  }
  get bond(){
    return this.calc_type === 'bond'
  }

  get asset_class_group(){
    let groups = this.constructor.employeeStore.asset_class_groups
    let acg = groups.find(acg => acg.id == this.asset_class_group_id)
    return acg
  }

  get liquid_readable(){
    if ((['Aktier', 'Obligationer'].includes(this.asset_class) && this.liquid_setting != 'alternative') || this.liquid_setting == 'liquid') {
      return 'Likvid'
    }

    return 'Alternativ'
  }

  get long_name(){
    return `${this.id} - ${this.name}`
  }
}
export default Issue
